export default __webpack_public_path__ + "static/image-27-53c75bc90f6f8addcf6dc61bc3635391.jpg";